import { Box } from '@mui/material';

interface Props {
  imgH?: number
  nameH?: number
  hidden?: boolean
  row?: boolean
}

const Logo = ({ imgH = 200, nameH = 70, hidden = false, row = false } : Props) => (
  <Box 
    display="flex" 
    flexDirection={row ? "row" : "column"} 
    alignItems="center" 
    justifyContent="center" 
    sx={{ pt: "12px" }}
  >
    <a href="https://www.captahydro.com" target="_blank" rel="noreferrer">
      <Box
        component="img" 
        sx={{
          height: 110,
        }}
        alt="master admin"
        src="/IsologotipoCapta.svg"
      />
    </a>

  </Box>
);

export default Logo;
